const evidenceTypesQueryKeys = {
  list: () => ["evidence-types", "list"],
  infiniteList: () => ["evidence-types", "infinite-list"],
  details: (id: number) => ["evidence-types", "list", { id }],
};

export const EvidenceTypesQuery = {
  queryKeys: evidenceTypesQueryKeys,
};
